import { stockWillMap, bondWillMap, stockListedMap, bondListedMap } from './fieldConfig/common';
import { plateStockListedMap, plateStockWillMap } from './fieldConfig/newThreePlate';


// new_plate 为新三板
const fieldStockMap: any = {
  wait_listing: stockWillMap,
  listed_performance: stockListedMap,
  new_plate_wait_listing: plateStockWillMap,
  new_plate_listed_performance: plateStockListedMap,
}

// new_plate 为新三板
const fieldBondMap: any = {
  wait_listing: bondWillMap,
  listed_performance: bondListedMap,
  new_plate_wait_listing: [],
  new_plate_listed_performance: [],
}

/**
 * @param { string } type 模块类型
 * @returns {} 模块字段配置
 */
const getStockMapData = (type: string) => {
  return fieldStockMap[type];
}

/**
 * @param { string } type 模块类型
 * @returns {} 模块字段配置
 */
const getBondMapData = (type: string) => {
  return fieldBondMap[type];
}

/**
 * @param { } data 接口返回数据
 * @param { } stockMap 配置的需要获取的字段配置
 * @returns {} 股票基本信息
 */
const getTitleData = (data: any, isBond: any) => {
  const resObj: any = {
    title: '名称代码',
    dataList: []
  }
  data.forEach((item: any, index: number) => {
    resObj.dataList.push({
      name: isBond ? item.bond_name : item.stock_name, // 股票名称
      code: isBond ? item.bond_code : item.stock_code, // 股票代码
      exchange: isBond ? 'BOND' : item.exchange, // 股票市场
      orderCode: item.order_code, // 股票申购代码
      marketId: item.market_id, // 市场id
      index
    })
  })
  return resObj;
};

/**
 * @param { } data 接口返回数据
 * @param { } stockMap 配置的需要获取的字段配置
 * @returns {} 符合渲染规范的股票基本信息
 */
const getListData = (data: any, stockMap: any) => {
  const resList: any = [];
  stockMap.forEach((item: any, index: number) => {
    const resObj: any = {
      title: item.name, // 标题名称
      dataList: [] // 该标题对应的数据
    }
    data.forEach((it: any, idx: number) => {
      resObj.dataList.push({
        value: it[item.field], // 数据值
        unit: item.unit, // 数据单位
        field: item.field, // 数据字段
        index: idx,
      })
    });
    resList.push(resObj)
  });
  return resList;
};

/**
 * @param { } item 接口返回数据
 * @param { } itemMap 配置的需要获取的字段配置
 * @returns {} 符合渲染规范的股票基本信息
 */
const getStockData = (data: any, stockMap: any, isBond?: boolean) => {
  if (!data || data.length === 0) {
    return {
      titleData: {},
      listData: [],
    };
  }
  return {
    titleData: getTitleData(data, isBond),
    listData: getListData(data, stockMap),
  };
}



/**
 * @param { } data 接口返回数据
 * @param { } stockMap 股票模块字段配置
 * @param { } bondMap 可转债模块字段配置
 * @returns {} stockCard组件可以使用的数据结构
 */
const getData = (data: any, stockMap: any, bondMap: any) => {
  return {
    stock: getStockData(data && data.stock, stockMap),
    bond: getStockData(data && data.bond, bondMap, true),
    page: data && data.page
  }
}

/**
 * @param { } data 接口返回数据
 * @param { string } type 模块类型
 * @returns {} stockCard组件可以使用的数据结构
 */
export function handleStockDataPerformance(data: any, type: string) {
  const fieldStockMap = getStockMapData(type);
  const fieldBondMap = getBondMapData(type);
  const resData = getData(data, fieldStockMap, fieldBondMap);
  return resData;
}